import type { FC } from "react";
import { PhotosTab } from "./photos-tab";

export const VectorTab: FC<{
  onImageClick?: (imageUrl: string) => void;
  selectedImage: string | null;
  onSelectionChange?: (hasSelection: boolean) => void;
  hidden?: boolean;
}> = (props) => {
  return <PhotosTab endpoint="/photos/vector" placeholder="Search curated images" {...props} />;
};
